import {
  mediaQueryInitialState,
  userInitialState,
  orderBumpFormInitialState,
  orderBumpPreviewInitialState,
  announcementInitialState
} from './features';
import { RootState } from './rootReducer';

const initialState: RootState = {
  user: userInitialState,
  mediaQuery: mediaQueryInitialState,
  orderBumpForm: orderBumpFormInitialState,
  orderBumpPreview: orderBumpPreviewInitialState,
  announcement: announcementInitialState
};

export default initialState;
